import { merge, of, pipe } from 'rxjs';
import { exhaustMap, filter, map, share, takeUntil, withLatestFrom } from 'rxjs/operators';
import { metaExpandDependent, metaFieldIndices, metaFieldName, metaValidationGroups } from '../../../utils/data';
import { runType } from '../../../validations/constants';
import validateFields from '../../../validations/validateFields';
import { actionNames } from '../../transfer/control';
import { updateValidationResult, updateValidationResultRapid } from '../../transfer/transmission';
import { filterByActionType } from '../../utils';
const singleRunner = ({ formFieldState$, formData$, formDescriptor$ }, reduxStore)=>pipe(withLatestFrom(formFieldState$, formData$, formDescriptor$), map(([action, formFieldState, formData, formDescriptor])=>validateFields({
            groups: metaValidationGroups(action),
            runType: runType.FIELD,
            fieldsToValidate: [
                [
                    metaFieldName(action),
                    metaFieldIndices(action)
                ]
            ],
            expandDependent: metaExpandDependent(action),
            formData,
            formFieldState,
            formDescriptor,
            reduxStore
        })));
export default (({ control$, ...other$ }, reduxStore)=>{
    const blur$ = control$.pipe(filterByActionType(actionNames.BLUR, actionNames.VALIDATE_FIELD), singleRunner(other$, reduxStore), map((payload)=>updateValidationResult(payload)), share());
    const rapid$ = control$.pipe(filter(({ type, meta })=>type === actionNames.SET_VALUE && meta.validationType), exhaustMap((action)=>// of(action) - sends initial action down to the validations
        merge(of(action), control$.pipe(filterByActionType(actionNames.SET_VALUE))).pipe(singleRunner(other$, reduxStore), map((payload)=>updateValidationResultRapid(payload)), takeUntil(control$.pipe(filterByActionType(actionNames.BLUR))))), share());
    const singleValidate$ = control$.pipe(filter(({ type, meta })=>type === actionNames.SET_VALUE && meta.validate), singleRunner(other$, reduxStore), map((payload)=>updateValidationResult(payload)), share());
    return merge(blur$, rapid$, singleValidate$);
});
